import * as React from "react";
import type { SVGProps } from "react";
const SvgIconMapLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_3371_16654)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14 1.49c-1.73.43-2.78.7-2.88.75-.68.3-1.2.92-1.4 1.65l-.06.2v7.36c0 5.17 0 7.41.02 7.56q.06.58.4 1.07c.5.77 1.43 1.19 2.35 1.06.1-.01 1.15-.26 2.32-.56l2.14-.53 1.32.33c1.22.3 1.33.33 1.5.32.3-.01.57-.19.7-.46.1-.19.12-.48.04-.69-.06-.17-.25-.37-.4-.45-.07-.04-.6-.18-1.22-.33l-1.09-.28v-7.86l.01-7.87 2.33.58 2.32.58v3.53l.07.13q.15.28.43.42c.13.06.18.07.35.07s.22 0 .35-.07q.29-.14.42-.42l.07-.13V5.68l.01-1.76 1.95-.49c2.13-.53 2.05-.52 2.3-.4l.21.17c.2.22.18.05.2 2.26v1.97l.07.13c.17.37.54.57.92.5q.27-.04.47-.24t.24-.48c.03-.2.03-3.52 0-3.85-.08-.9-.6-1.63-1.4-2.02-.36-.16-.58-.2-1.04-.21h-.38l-2.2.55-2.2.55-3.13-.78C8.9.98 8.08.79 8 .8c-.08 0-1.2.27-2.85.69m-.09 1.79-2.13.55c-.11.05-.27.2-.34.33l-.05.1v7.3l-.01 7.32.05.12c.06.15.23.32.39.4.22.09.25.08 2.3-.43l1.9-.47v-7.87c0-6.28-.01-7.87-.04-7.87zM17.1 9.57q-2.1.22-3.52 1.64c-1.43 1.44-1.96 3.49-1.44 5.53.5 1.91 1.92 3.89 4.07 5.65.43.35.86.67 1.02.74.25.12.56.1.8-.06.19-.11.72-.53 1.1-.84 2.22-1.86 3.64-4 3.98-6 .28-1.62-.08-3.16-1.05-4.45-.35-.47-.94-1.02-1.46-1.35q-1-.63-2.2-.82c-.23-.04-1.09-.07-1.3-.04m.18 1.71c-1.46.1-2.8 1.07-3.33 2.44q-.53 1.32-.09 2.78c.45 1.49 1.6 3.04 3.36 4.5l.35.29.19-.15c.88-.72 1.67-1.52 2.24-2.26.42-.54.66-.92.93-1.48.39-.8.55-1.47.55-2.22 0-2.28-1.92-4.06-4.2-3.9m-.1 2.3c-.55.11-1.06.6-1.21 1.18-.06.2-.06.63 0 .84.14.57.64 1.06 1.2 1.19.25.06.61.05.84-.01.55-.15.98-.58 1.16-1.14.06-.2.06-.71 0-.92-.08-.27-.2-.46-.44-.7-.17-.17-.25-.23-.42-.31-.11-.06-.28-.12-.37-.14-.2-.04-.55-.04-.75 0m.37 1.56c-.05.03-.02.1.03.1q.04 0 .04-.05 0-.08-.07-.05"
        fill="#475569"
      />
    </g>
    <defs>
      <clipPath id="clip0_3371_16654">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconMapLocation;
